module.exports = __webpack_public_path__ + "static/assets/2bae7059d4f81f344b02cc34567e548d.mp3";